// extracted by mini-css-extract-plugin
module.exports = {"padding-container":"wrapper_padding-container__Bm5c9","blackBg":"wrapper_blackBg__ZuIsK","primaryBg":"wrapper_primaryBg__H6Sbb"};